import { TransactionStatusEnum } from '../../../models/transaction-status.enum';
import {
  ArrayUtilities,
  SortOrder,
} from '../../../shared/utilities/array-utilities';
import { Injectable, OnDestroy } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SubscriptionProduct } from '../../../models/subscription-product';
import { ProductService } from '../../../services/product/product.service';

import { PriceStateModel } from './product.model';
import { Product } from './product.actions';
import { Price } from '../../../models/price';

@State<PriceStateModel>({
  name: 'Price',
  defaults: {
    items: undefined,
    selectedItem: undefined,
    updateItem: undefined,
    deleteId: undefined,
    isLoading: false,
  },
})
@Injectable()
export class PriceState implements OnDestroy {
  unSubscribeAll$ = new Subject<void>();
  constructor(private store: Store, private productService: ProductService) {}

  @Selector()
  static getItems(state: PriceStateModel): Price[] {
    return state.items;
  }

  @Selector()
  static getSelectedProduct(state: PriceStateModel): Price {
    return state.selectedItem;
  }

  @Action(Product.Actions.GetPrices)
  getPrices(
    { patchState, getState, dispatch }: StateContext<PriceStateModel>,
    action: Product.Actions.GetPrices
  ) {
    return this.productService
      .getPrices(action.productId)
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((prices) => {
        if (!prices) prices = [];
        const state = getState();
        const sortedPrices = ArrayUtilities.sort(
          prices,
          'amount',
          SortOrder.desc
        );
        patchState({
          items: [...sortedPrices],
          isLoading: false,
        });
      });
  }
  @Action(Product.Actions.SetPrices)
  setPrices(
    { patchState }: StateContext<PriceStateModel>,
    action: Product.Actions.SetPrices
  ) {
    patchState({
      items: [...action.prices],
      isLoading: false,
    });
    return action.prices;
    // });
  }

  @Action(Product.Actions.GetSelectedPrice)
  getSelectedPrice(
    ctx: StateContext<PriceStateModel>,
    action: Product.Actions.GetSelectedPrice
  ) {
    const state = ctx.getState();
    const selectedPrice = state.items.find(
      (trax) => trax.id === action.priceId
    );

    ctx.patchState({
      selectedItem: selectedPrice,
      isLoading: false,
    });
  }

  @Action(Product.Actions.EditPrice)
  editPrice(
    ctx: StateContext<PriceStateModel>,
    action: Product.Actions.EditPrice
  ): Subscription {
    const state = ctx.getState();
    const priceToUpdate = action.price;
    return this.productService
      .updatePrice(action.price.id, action.price)
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((trax) => {
        const currentItems = state.items;
        const updatedIndex = currentItems.findIndex((i) => i.id === trax.id);
        if (updatedIndex !== -1) {
          currentItems[updatedIndex] = trax;
          ctx.patchState({
            selectedItem: trax,
            items: { ...currentItems },
            isLoading: false,
          });
          // ctx.dispatch(
          //   new Product.Actions.GetBalances(
          //     state.primaryTransaction,
          //     currentItems
          //   )
          // );
        }
      });
  }

  @Action(Product.Actions.InsertPrice)
  insertTransaction(
    ctx: StateContext<PriceStateModel>,
    action: Product.Actions.InsertPrice
  ) {
    return this.productService
      .insertPrice(action.price)
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((price) => {
        const state = ctx.getState();
        let prices = state.items;
        if (!prices) prices = [];
        const items = [price, ...prices];
        ctx.patchState({
          items: items,
          isLoading: false,
          selectedItem: undefined,
          updateItem: price,
        });
      });
  }

  @Action(Product.Actions.DeletePrice)
  deletePrice(
    { getState, patchState, dispatch }: StateContext<PriceStateModel>,
    action: Product.Actions.DeletePrice
  ) {
    const price = { ...action.price };
    //  price.status = "Inactive";
    return this.productService
      .deletePrice(action.product.id, price)
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((transaction) => {
        const state = getState();
        const transactions = [...state.items];
        const campaignIndex = transactions.findIndex(
          (d) => d.id === transaction.id
        );

        if (campaignIndex >= 0) {
          transactions.splice(campaignIndex, 1);
        }

        patchState({
          items: [...transactions],
          updateItem: transaction,
          isLoading: false,
        });
      });
  }

  ngOnDestroy(): void {
    this.unSubscribeAll$.next();
    this.unSubscribeAll$.complete();
  }
}
